import { render, staticRenderFns } from "./CSlideControlPrev.vue?vue&type=template&id=20b49ce6"
import script from "./CSlideControlPrev.vue?vue&type=script&lang=js"
export * from "./CSlideControlPrev.vue?vue&type=script&lang=js"
import style0 from "./CSlideControlPrev.vue?vue&type=style&index=0&id=20b49ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
